import { Outlet } from 'react-router-dom';
import { MasterSidebar } from './MasterSidebar';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { Crown } from 'lucide-react';

export function MasterLayout() {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <MasterSidebar />
        <main className="flex-1 overflow-auto">
          <header className="sticky top-0 z-10 flex h-14 items-center gap-4 border-b bg-background/95 px-6 backdrop-blur supports-[backdrop-filter]:bg-background/60">
            <SidebarTrigger />
            <div className="flex items-center gap-2">
              <Crown className="h-5 w-5 text-yellow-500" />
              <h1 className="text-lg font-semibold">Painel Master</h1>
            </div>
          </header>
          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
}
